var pagerClamp = {
    selector: '.post-detail__pager__title',
    init: function() {
        var self = this,
            elements = document.querySelectorAll( self.selector );

        if ( ! elements.length ) {
            return;
        }

        var run = function() {
            elements.forEach( function( element ) {
                self.clamp( element );
            } );
        };

        if ( document.fonts && document.fonts.ready ) {
            document.fonts.ready.then( run );
        }
        else {
            run();
        }

        var resizeTimer;

        window.addEventListener( 'resize', function() {
            clearTimeout( resizeTimer );
            resizeTimer = setTimeout( run, 150 );
        } );
    },
    clamp: function( element ) {
        var full = element.getAttribute( 'data-full-text' );

        if ( ! full ) {
            full = element.textContent;
            element.setAttribute( 'data-full-text', full );
        }

        element.textContent = full;

        var styles     = window.getComputedStyle( element ),
            lineHeight = parseFloat( styles.lineHeight ),
            maxLines   = parseInt( styles.webkitLineClamp, 10 ) || 3,
            countLines = function() {
                return Math.round( element.scrollHeight / lineHeight );
            };

        if ( countLines() <= maxLines ) {
            return;
        }

        var words = full.split( ' ' );

        while ( words.length > 1 && countLines() > maxLines ) {
            words.pop();
            element.textContent = words.join( ' ' ).replace( /[.,:;]$/, '' ) + '…';
        }
    }
};

export {
    pagerClamp
};
